<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <v-app>
                        <v-container fluid>
                            <v-card elevation="2" outlined>
                                <v-card-title>
                                    <!--                                    v-if="$can('transaction_create')"-->

                                    <v-spacer/>
                                    {{ $route.meta.title }}
                                    <v-spacer/>


                                </v-card-title>
                                <v-divider/>
                              <div class="row mb-1">
                                <div class="col-md-4">
                                  <select
                                      @change="reloadTable1(tableProps)"
                                      v-model="tableProps.type"
                                      class="form-control">
                                    <option value>نوع تراکنش</option>
                                    <option value='deposit'>افزایش</option>
                                    <option value='withdraw'>کسر</option>
                                  </select>
                                </div>
                                <div class="col-md-4">
                                  <select
                                      @change="reloadTable1(tableProps)"
                                      v-model="tableProps.confirmed"
                                      class="form-control">
                                    <option value>همه ی وضعیت ها</option>
                                    <option value='true'>تایید شده</option>
                                    <option value='false'>تایید نشده</option>
                                  </select>
                                </div>
                                <div class="col-md-4">

                                  <date-picker label="تاریخ تراکنش"
                                               v-model="tableProps.date"
                                               v-on:input="reloadTable1(tableProps)"
                                               format="YYYY-MM-DD"
                                               display-format="jYYYY-jMM-jDD"

                                  />

<!--                                  <input-->
<!--                                      name="name"-->
<!--                                      class="form-control"-->
<!--                                      placeholder="Search Table">-->
                                </div>
                              </div>
                                <div class="row">
                                    <div class="col-md-12 p-5">

                                      <data-table
                                          :data="transactions"
                                          :columns="columnTransactions"
                                          :translate="translate"
                                          :per-page="[10, 25, 50, 100]"
                                          @on-table-props-changed="reloadTable">


                                      </data-table>

                                    </div>
                                </div>
                            </v-card>
                        </v-container>
                    </v-app>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import transactionBtn from "@/view/pages/admin/transactions/transactionBtn";
import Wallet from "./actions/Wallet";

export default {
  components: {Wallet},
  data() {
        return {
          dialog: false,
          userWallet: [],
          transactionUrl: 'admin/transactions',
          transactions: {},
          dialogInfo: null,
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            url: 'admin/users',
            userInfo:{},
            tableProps: {
                search: '',
                type: '',
                confirmed: '',
                date: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
          columnTransactions: [
            {
              label: 'شناسه',
              name: 'id',
              orderable: true,
              colStyle: 'width: 100px;'
            },
            {
              name: 'uuid',
              label: 'شناسه پرداخت',
              orderable: true,

            },
            {
              name: 'amount',
              label: 'قیمت(﷼)',
              orderable: true,
              transform: (value) => {
                return this.$options.filters.rial(value.data.amount);
              },
            },
            {
              name: 'type',
              label: 'نوع',
              transform: (value) => {
                return value.data.type === 'deposit'
                    ? `<span class="badge-pill badge badge-success">افزایش موجودی</span>`
                    : `<span class="badge-pill badge badge-danger">کسر موجودی</span>`
              }
            },
            {
              name: 'confirmed',
              label: 'وضعیت',
              transform: (value) => {
                return value.data.confirmed === true
                    ? `<span class="badge-pill badge badge-info">تایید شده</span>`
                    : `<span class="badge-pill badge badge-danger">رد شده</span>`
              }

            },

            {
              name: 'created_at',
              label: 'تاریخ',
              orderable: true,
              transform: (value) => {
                return this.dateString(value.data.created_at);
              },
            },
            {
              label: 'عملیات',
              name: 'actions',
              component: transactionBtn,
              handler: this.actions,
              event: 'action',
              meta: {
                permission_prefix: 'adminTransaction_',
              }
            },



          ],
        }
    },
    created() {
        this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
      this.getUserTransactions(this.transactionUrl);
    },

    methods: {
        filterOnlyCapsText(value, search, item) {
            return value != null &&
                search != null &&
                typeof value === 'string' &&
                value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

      getUserTransactions(url = this.transactionUrl, params = this.tableProps) {
        this.loading = true;
        this.requestApiGet(this.transactionUrl, params).then(response => {
          this.transactions = response.data;
          this.loading = false;
        });
      },
      reloadTable(tableProps) {
        this.getUserTransactions(this.transactionUrl, tableProps);
      },
      reloadTable1(tableProps) {
        this.getUserTransactions(this.transactionUrl, tableProps);
      },
      updateValue() {
        this.reloadTable1(this.transactionUrl,tableProps)
      },
        actions(data, type) {
          this[type](data)
        },
      edit(data) {
        this.$router.push({name: 'admin.transactions.show', params: {id: data.id}})
      },
      information(data) {
        this.$router.push({name: 'admin.transactions.show', params: {id: data.id}})
      },
    }
}
</script>
